<template>
<el-dialog
  title="修改密码"
  :visible.sync="visible"
  :append-to-body="true"
  :before-close="clearValidate"
  custom-class="custom-dialog"
  width="350px"
>
  <el-form ref="form" :model="model" @keydown.native.enter="onSubmitBtnClick">
    <el-form-item
      label="旧密码"
      prop="oldPassword"
      :rules="[{
        required: true,
        message: '请填写旧密码'
      }]"
    >
      <el-input v-model.trim="model.oldPassword" type="password" />
    </el-form-item>

    <el-form-item
      label="新密码"
      prop="newPassword"
      :rules="[{
        required: true,
        message: '请填写新密码'
      }]"
    >
      <el-input v-model.trim="model.newPassword" type="password" />
    </el-form-item>

    <el-form-item
      label="确认密码"
      prop="repeatPassword"
      :rules="[{
        validator: this.validatorRepeatPassword
      }]"
    >
      <el-input v-model.trim="model.repeatPassword" type="password" />
    </el-form-item>
  </el-form>

  <template slot="footer">
    <el-button type="orange" style="width:100px;" @click="onSubmitBtnClick">确定</el-button>
    <el-button style="width:100px;" @click="onCancelBtnClick">取消</el-button>
  </template>
</el-dialog>
</template>

<script>
import BaseStore from '../BaseStore'
import * as EventKeyMap from './EventKeys'
import CryptoJS from 'crypto-js'

const SECRET_KEY = 'MORE.BEISE'

export default {
  name: 'LayoutModifyPassword',
  extends: BaseStore,
  data () {
    return {
      visible: false,
      model: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: ''
      }
    }
  },
  computed: {
    userMenu () {
      return {
        icon: 'fa-lock',
        label: '修改密码',
        click: this.showModifyPasswordDialog
      }
    }
  },
  methods: {
    showModifyPasswordDialog () {
      this.visible = true
    },
    onSubmitBtnClick () {
      this.$refs.form.validate(flag => {
        if (!flag) {
          return
        }

        let model = Object.assign({}, this.model)

        model.oldPassword = CryptoJS.DES.encrypt(model.oldPassword, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
        model.repeatPassword = CryptoJS.DES.encrypt(model.repeatPassword, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
        model.newPassword = CryptoJS.DES.encrypt(model.newPassword, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }).toString()

        this.$api.Profile.changePassword(model).then(data => {
          if (data) {
            this.visible = false
          }
        }).catch(console.error)
      })
    },
    restoreForm () {
      this.model = {
        oldPassword: '',
        newPassword: '',
        repeatPassword: ''
      }
    },
    clearValidate () {
      this.restoreForm()
      setTimeout(() => {
        this.$refs.form.clearValidate()
        this.visible = false
      }, 10)
    },
    onCancelBtnClick () {
      this.clearValidate()
      this.visible = false
    },
    validatorRepeatPassword (rule, value, callback) {
      let newPassword = this.model.newPassword

      if (newPassword) {
        if (newPassword !== value) {
          return callback(new Error('确认密码和新密码需要保持一致'))
        }
      }

      callback()
    }
  },
  created () {
    this.$eventBus.emit(EventKeyMap.USER_MENU_REGISTER, this.userMenu)
  },
  beforeDestroy () {
    this.$eventBus.emit(EventKeyMap.USER_MENU_DESTROY, this.userMenu)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/ModifyPassword.vue